// extracted by mini-css-extract-plugin
module.exports = {"overlay":"mobile-menu_overlay__CWevW","wrapper_menu_mobile":"mobile-menu_wrapper_menu_mobile__L2Dek","closeBtn":"mobile-menu_closeBtn__Af_Lk"};